import { render, staticRenderFns } from "./_TableSubrow.vue?vue&type=template&id=0b7f831c&scoped=true&"
import script from "./_TableSubrow.vue?vue&type=script&lang=ts&"
export * from "./_TableSubrow.vue?vue&type=script&lang=ts&"
import style0 from "./_TableSubrow.vue?vue&type=style&index=0&id=0b7f831c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7f831c",
  null
  
)

component.options.__file = "_TableSubrow.vue"
export default component.exports